import Link from 'next/link';

import VirtualRequest from '@/public/img/cards/virtual-quote-request.webp';
import InPersonRequest from '@/public/img/cards/hvac-tech-in-person.webp';
import Image from 'next/image';
import { SpaceWow } from '@/components/SpaceWow';
import { Badge } from '@/components/Badge';

export interface QuoteTypeSelectorProps {
	testId?: string;
}

const QuoteTypeSelector = (props: QuoteTypeSelectorProps) => {
	const { testId = 'QuoteTypeSelector' } = props;

	return (
		<div
			data-testid={testId}
			className="flex flex-col items-center justify-center gap-4 lg:flex-row lg:items-stretch lg:gap-6"
		>
			{cardsData.map((card) => (
				<Link
					key={card._id}
					href={card.link}
					className="w-full max-w-80 overflow-hidden rounded-2xl md:max-w-90"
				>
					<div className="relative h-full">
						<div className="peer relative z-10 flex h-41 w-full items-center justify-center overflow-hidden lg:h-45">
							{card.badge && (
								<div className="absolute bottom-4 right-4 z-10 rounded-md bg-white">
									<Badge color={card.badge.color}>{card.badge.label}</Badge>
								</div>
							)}
							<Image
								src={card.image}
								alt={card.imageAlt}
								className="min-h-full object-cover"
							/>
						</div>
						<div className="px-4 pb-5 pt-4 lg:pb-6 lg:pt-5">
							<div className="text-center">
								<strong className="mb-1 text-base lg:text-lg">
									{card.title}
								</strong>
								<p className="text-balance text-sm lg:text-base">
									{card.subtitle}
								</p>
							</div>
							<SpaceWow spacer_05 />
							<ol className="mx-auto flex w-fit list-inside list-decimal flex-col gap-1">
								{card.features.map((line) => (
									<li key={line} className="text-xs text-slate-500 lg:text-sm">
										{line}
									</li>
								))}
							</ol>
						</div>
						<div className="absolute bottom-0 top-0 z-0 w-full rounded-2xl border-2 border-slate-300 hover:border-2 hover:border-black focus:border-black peer-hover:border-black"></div>
					</div>
				</Link>
			))}
		</div>
	);
};

const cardsData = [
	{
		_id: 1,
		title: 'Replace Your System Quickly',
		subtitle: 'Get a trusted, local HVAC partner on-site for faster service',
		link: '/replace/in-person/',
		features: [
			'Answer a few questions online',
			'We match you with one HVAC partner',
			'Get the right system, guided by experts',
			'Lock in a price for your new system',
			'Get your new system installed',
		],
		image: InPersonRequest,
		imageAlt: 'HVAC technician smiling',
		badge: {
			color: 'hvac' as const,
			label: 'Faster',
		},
	},
	{
		_id: 2,
		title: 'Start With An Estimate',
		subtitle: 'Get a price range before\nmoving forward',
		link: '/replace/virtual/',
		features: [
			'Answer a few questions online',
			'Get an initial project estimate online',
			'Dial in the details with your advisor',
			'Schedule on-site visit for final pricing',
			'Get your new system installed',
		],
		image: VirtualRequest,
		imageAlt: 'men in phone connecting with operator on the other side',
		badge: null,
	},
];

export default QuoteTypeSelector;
